module.exports = __webpack_public_path__ + "static/media/swords.7c2bbb5e.svg";